var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2638 16.265L21.975 12.1852C22.1526 11.1662 21.3627 10.2342 20.3214 10.2342H15.0988C14.5811 10.2342 14.187 9.77328 14.2708 9.26598L14.9387 5.22142C15.0473 4.56435 15.0163 3.892 14.8478 3.24752C14.7081 2.71364 14.2929 2.28495 13.7469 2.11093L13.6007 2.06435C13.2707 1.95918 12.9105 1.98365 12.5994 2.13239C12.2569 2.29611 12.0063 2.59473 11.9135 2.94989L11.434 4.78374C11.2814 5.36723 11.0591 5.93045 10.7726 6.46262C10.3539 7.24017 9.70656 7.86246 9.03367 8.43769L7.58339 9.67749C7.17448 10.0271 6.95973 10.5506 7.00626 11.0844V20C7.00626 21.1046 7.90169 22 9.00626 22H14.1827C17.692 22 20.6868 19.5744 21.2638 16.265Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64343 10C5.52986 10.3636 5.48162 10.7492 5.50625 11.1392V20C5.50625 20.7401 5.73595 21.4265 6.12796 21.9919C6.08606 21.9972 6.04335 22 6 22H3C2.44772 22 2 21.5523 2 21V11C2 10.4477 2.44772 10 3 10H5.64343Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.3f9a0aa5ee34477f9bbd0942caa4c27f.svg";
export { ForwardRef as ReactComponent };